import { StrictMode, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import './estilos.css';
import { esAppNativa, servidorEfectivo } from './lib/servidor';
import { ProveedorSesion } from './lib/sesion';
import { PantallaServidor } from './rutas/servidor';

/**
 * En el APK, el primer arranque no tiene servidor todavía. Se pregunta aquí
 * arriba, antes de montar la sesión: `ProveedorSesion` revalida el token contra
 * el API nada más nacer, y sin dirección esa petición iría al propio teléfono.
 *
 * En el navegador la condición es falsa desde el principio y esto no se ve.
 */
function Raiz() {
  const [hayServidor, setHayServidor] = useState(!esAppNativa() || servidorEfectivo() !== null);

  if (!hayServidor) return <PantallaServidor alGuardar={() => setHayServidor(true)} />;

  return (
    <ProveedorSesion>
      <App />
    </ProveedorSesion>
  );
}

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('Falta #raiz en index.html');

createRoot(raiz).render(
  <StrictMode>
    <BrowserRouter>
      <Raiz />
    </BrowserRouter>
  </StrictMode>,
);
